// Get the type of walldisplay based on product's handle
const handle = window.product !== undefined ? window.product.handle : null;
const wdType = handle !== null ? handle.split("wall-display-")[1] : null;

// Return builder mask info based on type
const wallDisplays = {
  linville: {
    Canvas_1: {
      width: 260,
      height: 208,
      left: 175,
      top: 133,
      canvasWidth: 20,
      canvasHeight: 16
    },
    Canvas_2: {
      width: 104,
      height: 130,
      left: 57,
      top: 131,
      canvasWidth: 8,
      canvasHeight: 10
    },
    Canvas_3: {
      width: 104,
      height: 130,
      left: 450,
      top: 212,
      canvasWidth: 8,
      canvasHeight: 10
    }
  },
  stairway: {
    Canvas_1: {
      width: 160,
      height: 200,
      left: 222,
      top: 135,
      canvasWidth: 16,
      canvasHeight: 20
    },
    Canvas_2: {
      width: 80,
      height: 100,
      left: 12,
      top: 307,
      canvasWidth: 8,
      canvasHeight: 10
    },
    Canvas_3: {
      width: 110,
      height: 140,
      left: 102,
      top: 237,
      canvasWidth: 11,
      canvasHeight: 14
    },
    Canvas_4: {
      width: 110,
      height: 140,
      left: 392,
      top: 93,
      canvasWidth: 11,
      canvasHeight: 14
    },
    Canvas_5: {
      width: 80,
      height: 100,
      left: 512,
      top: 63,
      canvasWidth: 8,
      canvasHeight: 10
    }
  },
  catawba: {
    Canvas_1: {
      width: 216,
      height: 144,
      left: 197,
      top: 165,
      canvasWidth: 18,
      canvasHeight: 12
    },
    Canvas_2: {
      width: 96,
      height: 96,
      left: 89,
      top: 100,
      canvasWidth: 8,
      canvasHeight: 8
    },
    Canvas_3: {
      width: 96,
      height: 144,
      left: 197,
      top: 8,
      canvasWidth: 8,
      canvasHeight: 12
    },
    Canvas_4: {
      width: 144,
      height: 96,
      left: 305,
      top: 56,
      canvasWidth: 12,
      canvasHeight: 8
    },
    Canvas_5: {
      width: 144,
      height: 96,
      left: 423,
      top: 165,
      canvasWidth: 12,
      canvasHeight: 8
    },
    Canvas_6: {
      width: 96,
      height: 96,
      left: 423,
      top: 275,
      canvasWidth: 8,
      canvasHeight: 8
    },
    Canvas_7: {
      width: 96,
      height: 144,
      left: 316,
      top: 322,
      canvasWidth: 8,
      canvasHeight: 12
    },
    Canvas_8: {
      width: 144,
      height: 96,
      left: 159,
      top: 322,
      canvasWidth: 12,
      canvasHeight: 8
    },
    Canvas_9: {
      width: 144,
      height: 96,
      left: 42,
      top: 212,
      canvasWidth: 12,
      canvasHeight: 8
    }
  },
  glassmine: {
    Canvas_1: {
      width: 216,
      height: 288,
      left: 77,
      top: 93,
      canvasWidth: 18,
      canvasHeight: 24
    },
    Canvas_2: {
      width: 216,
      height: 144,
      left: 317,
      top: 93,
      canvasWidth: 18,
      canvasHeight: 12
    },
    Canvas_3: {
      width: 96,
      height: 120,
      left: 317,
      top: 261,
      canvasWidth: 8,
      canvasHeight: 10
    },
    Canvas_4: {
      width: 96,
      height: 120,
      left: 435,
      top: 261,
      canvasWidth: 8,
      canvasHeight: 10
    }
  },
  shunkawauken: {
    Canvas_1: {
      width: 240,
      height: 180,
      left: 175,
      top: 147,
      canvasWidth: 24,
      canvasHeight: 18
    },
    Canvas_2: {
      width: 100,
      height: 80,
      left: 53,
      top: 147,
      canvasWidth: 10,
      canvasHeight: 8
    },
    Canvas_3: {
      width: 120,
      height: 180,
      left: 437,
      top: 147,
      canvasWidth: 12,
      canvasHeight: 18
    },
    Canvas_4: {
      width: 100,
      height: 80,
      left: 53,
      top: 247,
      canvasWidth: 10,
      canvasHeight: 8
    }
  },
  mingo: {
    Canvas_1: {
      width: 210,
      height: 112,
      left: 201,
      top: 181,
      canvasWidth: 30,
      canvasHeight: 16
    },
    Canvas_2: {
      width: 140,
      height: 140,
      left: 201,
      top: 27,
      canvasWidth: 20,
      canvasHeight: 20
    },
    Canvas_3: {
      width: 126,
      height: 84,
      left: 355,
      top: 83,
      canvasWidth: 18,
      canvasHeight: 12
    },
    Canvas_4: {
      width: 140,
      height: 140,
      left: 425,
      top: 181,
      canvasWidth: 20,
      canvasHeight: 20
    },
    Canvas_5: {
      width: 140,
      height: 140,
      left: 271,
      top: 308,
      canvasWidth: 20,
      canvasHeight: 20
    },
    Canvas_6: {
      width: 126,
      height: 84,
      left: 131,
      top: 308,
      canvasWidth: 18,
      canvasHeight: 12
    },
    Canvas_7: {
      width: 140,
      height: 140,
      left: 47,
      top: 154,
      canvasWidth: 20,
      canvasHeight: 20
    }
  },
  "hickory-nut": {
    Canvas_1: {
      width: 234,
      height: 234,
      left: 188,
      top: 120,
      canvasWidth: 26,
      canvasHeight: 26
    },
    Canvas_2: {
      width: 108,
      height: 108,
      left: 62,
      top: 120,
      canvasWidth: 12,
      canvasHeight: 12
    },
    Canvas_3: {
      width: 108,
      height: 108,
      left: 62,
      top: 246,
      canvasWidth: 12,
      canvasHeight: 12
    },
    Canvas_4: {
      width: 108,
      height: 108,
      left: 440,
      top: 120,
      canvasWidth: 12,
      canvasHeight: 12
    },
    Canvas_5: {
      width: 108,
      height: 108,
      left: 440,
      top: 246,
      canvasWidth: 12,
      canvasHeight: 12
    }
  },
  cullasaja: {
    Canvas_1: {
      width: 180,
      height: 260,
      left: 115,
      top: 107,
      canvasWidth: 18,
      canvasHeight: 26
    },
    Canvas_2: {
      width: 180,
      height: 120,
      left: 315,
      top: 107,
      canvasWidth: 18,
      canvasHeight: 12
    },
    Canvas_3: {
      width: 180,
      height: 120,
      left: 315,
      top: 247,
      canvasWidth: 18,
      canvasHeight: 12
    }
  },
  wildcat: {
    Canvas_1: {
      width: 216,
      height: 324,
      left: 197,
      top: 75,
      canvasWidth: 24,
      canvasHeight: 36
    },
    Canvas_2: {
      width: 90,
      height: 72,
      left: 89,
      top: 88,
      canvasWidth: 10,
      canvasHeight: 8
    },
    Canvas_3: {
      width: 162,
      height: 108,
      left: 17,
      top: 178,
      canvasWidth: 18,
      canvasHeight: 12
    },
    Canvas_4: {
      width: 90,
      height: 72,
      left: 89,
      top: 304,
      canvasWidth: 10,
      canvasHeight: 8
    },
    Canvas_5: {
      width: 90,
      height: 72,
      left: 431,
      top: 88,
      canvasWidth: 10,
      canvasHeight: 8
    },
    Canvas_6: {
      width: 162,
      height: 108,
      left: 431,
      top: 178,
      canvasWidth: 18,
      canvasHeight: 12
    },
    Canvas_7: {
      width: 90,
      height: 72,
      left: 431,
      top: 304,
      canvasWidth: 10,
      canvasHeight: 8
    }
  },
  crabtree: {
    Canvas_1: {
      width: 240,
      height: 370,
      left: 105,
      top: 52,
      canvasWidth: 24,
      canvasHeight: 37
    },
    Canvas_2: {
      width: 140,
      height: 110,
      left: 365,
      top: 52,
      canvasWidth: 14,
      canvasHeight: 11
    },
    Canvas_3: {
      width: 140,
      height: 110,
      left: 365,
      top: 182,
      canvasWidth: 14,
      canvasHeight: 11
    },
    Canvas_4: {
      width: 140,
      height: 110,
      left: 365,
      top: 312,
      canvasWidth: 14,
      canvasHeight: 11
    }
  },
  setrock: {
    Canvas_1: {
      width: 272,
      height: 192,
      left: 169,
      top: 141,
      canvasWidth: 34,
      canvasHeight: 24
    },
    Canvas_2: {
      width: 144,
      height: 192,
      left: 12,
      top: 141,
      canvasWidth: 18,
      canvasHeight: 24
    },
    Canvas_3: {
      width: 144,
      height: 192,
      left: 454,
      top: 141,
      canvasWidth: 18,
      canvasHeight: 24
    }
  },
  sunburst: {
    Canvas_1: {
      width: 266,
      height: 168,
      left: 164,
      top: 199,
      canvasWidth: 38,
      canvasHeight: 24
    },
    Canvas_2: {
      width: 126,
      height: 168,
      left: 30,
      top: 107,
      canvasWidth: 18,
      canvasHeight: 24
    },
    Canvas_3: {
      width: 126,
      height: 84,
      left: 164,
      top: 107,
      canvasWidth: 18,
      canvasHeight: 12
    },
    Canvas_4: {
      width: 126,
      height: 84,
      left: 304,
      top: 107,
      canvasWidth: 18,
      canvasHeight: 12
    },
    Canvas_5: {
      width: 126,
      height: 168,
      left: 438,
      top: 107,
      canvasWidth: 18,
      canvasHeight: 24
    },
    Canvas_6: {
      width: 126,
      height: 84,
      left: 30,
      top: 283,
      canvasWidth: 18,
      canvasHeight: 12
    },
    Canvas_7: {
      width: 126,
      height: 84,
      left: 438,
      top: 283,
      canvasWidth: 18,
      canvasHeight: 12
    }
  },
  rainbow: {
    Canvas_1: {
      width: 264,
      height: 176,
      left: 173,
      top: 63,
      canvasWidth: 24,
      canvasHeight: 16
    },
    Canvas_2: {
      width: 132,
      height: 198,
      left: 23,
      top: 161,
      canvasWidth: 12,
      canvasHeight: 18
    },
    Canvas_3: {
      width: 132,
      height: 198,
      left: 455,
      top: 161,
      canvasWidth: 12,
      canvasHeight: 18
    },
    Canvas_4: {
      width: 121,
      height: 154,
      left: 173,
      top: 257,
      canvasWidth: 11,
      canvasHeight: 14
    },
    Canvas_5: {
      width: 121,
      height: 154,
      left: 316,
      top: 257,
      canvasWidth: 11,
      canvasHeight: 14
    }
  },
  "silver-run": {
    Canvas_1: {
      width: 240,
      height: 300,
      left: 18,
      top: 87,
      canvasWidth: 16,
      canvasHeight: 20
    },
    Canvas_2: {
      width: 165,
      height: 210,
      left: 267,
      top: 87,
      canvasWidth: 11,
      canvasHeight: 14
    },
    Canvas_3: {
      width: 150,
      height: 120,
      left: 441,
      top: 87,
      canvasWidth: 10,
      canvasHeight: 8
    }
  }
};

const wallDisplay = wallDisplays[wdType] || {};
Object.keys(wallDisplay).forEach((canvasKey) => {
  const { width, height, canvasWidth, canvasHeight } = wallDisplay[canvasKey];
  wallDisplay[
    canvasKey
  ].rawDimensions = `${height}_${width}_${canvasHeight}_${canvasWidth}`;
  wallDisplay[canvasKey].dimensions = `${canvasHeight}x${canvasWidth}`;
});

export default wallDisplay;
